export const CAMERA_PERMISSION_STATE = {
  UNKNOWN: 'unknown',
  GRANTED: 'granted',
  DENIED: 'denied',
};

export const CAMERA_STATUS = {
  IDLE: 'idle',
  INITIALIZING: 'initializing',
  READY: 'ready',
  SWITCHING: 'switching',
  ERROR: 'error',
  STOPPED: 'stopped',
};

// MediaPipe's own frame reader caps detection at 640px (see
// MAX_DETECTION_SIDE in use-predict-worker.jsx) — this is purely a
// preview/recording-sharpness default for the real capture stream below, not
// a detection-accuracy one.
export const DEFAULT_CAPTURE_WIDTH = 1280;
